<template>
  <div class="page-relative cinemas-wrapper">
      <MovieBackground :topStyle="topstyle" :botStyle="botstyle" :layOutStyle="layout"/>
      <!-- 搜索 -->
      <MovieSearch></MovieSearch>
      <div class="filter page-relative">
          <div class="page-margin-auto page-text-center region" :class="{'font-color-red':filterRegion }" @click="openRegion">
              {{currentRegion}}<span v-if="!filterRegion">▼</span><span v-if="filterRegion">▲</span>
          </div>
          <div class="page-absolute region-layout" v-if="filterRegion">
              <span class="page-inline-block item-region" v-for="(item, ind) in regionList" :key="ind" @click="chooseRegion(item)">{{item.name}}</span>
          </div>
      </div>
      <!-- 影院数据 -->
      <div class="movie-box cinemas-content">
          <router-link v-for="(item, ind) in list" :key="ind" :to="'/cinemasDetails'">
             <div class="movie-box cinemas-list">
                 <!-- 电影标题 -->
              <div class="acea-row row-middle row-between title-and-price">
                <div class="page-text-ellipsis-nowrap title">{{item.name}}</div>
                <div class="price"><span>{{item.lowPrice}}</span>元起</div>
              </div>
              <!-- 地址距离 -->
              <div class="acea-row row-middle row-between address-wrapper">
                <div class="page-text-ellipsis-nowrap address">{{item.address}}</div>
                <div class="distance">>{{item.distance}}km</div>
              </div>
              <!-- 标签 -->
              <ul class="acea-row features">
                  <li v-for="(val,key) in item.features" :key="key">{{val.name}}</li>
              </ul>
              <!-- 卡 -->
              <div class="ka-wrapper">
                  <img src="@assets/images/ka.png" />
                  <span>{{item.card}}</span>
              </div>
              <!-- 惠 -->
              <div class="ka-wrapper">
                  <img src="@assets/images/hui.png" />
                  <span>{{item.discount}}</span>
              </div>
             </div>
          </router-link>
      </div>
  </div>
</template>

<script>
import MovieSearch from "@components/MovieSearch";
import MovieBackground from "@components/MovieBackground";

export default {
    name:"Cinemas",
    components:{
        MovieSearch,
        MovieBackground
    },
    data:function(){
        return {
            filterRegion: false,
            topstyle: {
                background:'linear-gradient(-90deg, #FF0B46 0%, #FFAF98 100%)',
                height: '1.4rem'
            },
            botstyle:{
                background:'linear-gradient(-90deg, #FF0B46 0%, #FFAF98 100%)',
                height: '0.5rem',
                'border-radius': '0 0 1rem 1rem'
            },
            layout: {
                'z-index': -1
            },
            list:[
                {
                    address: "里水镇和顺大道8号万福城购物广场4楼",
                    cityId: 5,
                    distance: 187,
                    districtId: 63,
                    features: [
                    {name: "自费购买", desc: "5-15元/副"},
                    {name: "可停车", desc: "商场停车场3小时内免费停车"},
                    {name: "儿童票", desc: "1.3米以下儿童免票观看电影但无座，1名家长仅可以带1名儿童。儿童有座半价观影。"},
                    {name: "有WIFI", desc: "提供免费WIFI"},
                    {name: "自费购买", desc: "5-15元/副"},
                    {name: "可停车", desc: "商场停车场3小时内免费停车"},
                    {name: "儿童票", desc: "1.3米以下儿童免票观看电影但无座，1名家长仅可以带1名儿童。儿童有座半价观影。"},
                    {name: "有WIFI", desc: "提供免费WIFI"}
                    ],
                    id: 106367,
                    lowPrice: 35.5,
                    name: "星辉影城（和顺店）",
                    card:"开卡特惠 最高立减20元",
                    discount:"《你好，李焕英》等7部电影特惠"
                }, {
                    address: "里水镇和顺大道8号万福城购物广场4楼",
                    cityId: 5,
                    distance: 187,
                    districtId: 63,
                    features: [
                    {name: "自费购买", desc: "5-15元/副"},
                    {name: "可停车", desc: "商场停车场3小时内免费停车"},
                    {name: "儿童票", desc: "1.3米以下儿童免票观看电影但无座，1名家长仅可以带1名儿童。儿童有座半价观影。"},
                    {name: "有WIFI", desc: "提供免费WIFI"}],
                    id: 106367,
                    lowPrice: 35.5,
                    name: "星辉影城（和顺店）",
                    card:"开卡特惠 最高立减20元",
                    discount:"《你好，李焕英》等7部电影特惠"
                }, {
                    address: "里水镇和顺大道8号万福城购物广场4楼",
                    cityId: 5,
                    distance: 187,
                    districtId: 63,
                    features: [
                    {name: "自费购买", desc: "5-15元/副"},
                    {name: "可停车", desc: "商场停车场3小时内免费停车"},
                    {name: "儿童票", desc: "1.3米以下儿童免票观看电影但无座，1名家长仅可以带1名儿童。儿童有座半价观影。"},
                    {name: "有WIFI", desc: "提供免费WIFI"}],
                    id: 106367,
                    lowPrice: 35.5,
                    name: "星辉影城（和顺店）",
                    card:"开卡特惠 最高立减20元",
                    discount:"《你好，李焕英》等7部电影特惠"
                },{
                    address: "里水镇和顺大道8号万福城购物广场4楼",
                    cityId: 5,
                    distance: 187,
                    districtId: 63,
                    features: [
                    {name: "自费购买", desc: "5-15元/副"},
                    {name: "可停车", desc: "商场停车场3小时内免费停车"},
                    {name: "儿童票", desc: "1.3米以下儿童免票观看电影但无座，1名家长仅可以带1名儿童。儿童有座半价观影。"},
                    {name: "有WIFI", desc: "提供免费WIFI"}],
                    id: 106367,
                    lowPrice: 35.5,
                    name: "星辉影城（和顺店）",
                    card:"开卡特惠 最高立减20元",
                    discount:"《你好，李焕英》等7部电影特惠"
                },{
                    address: "里水镇和顺大道8号万福城购物广场4楼",
                    cityId: 5,
                    distance: 187,
                    districtId: 63,
                    features: [
                    {name: "自费购买", desc: "5-15元/副"},
                    {name: "可停车", desc: "商场停车场3小时内免费停车"},
                    {name: "儿童票", desc: "1.3米以下儿童免票观看电影但无座，1名家长仅可以带1名儿童。儿童有座半价观影。"},
                    {name: "有WIFI", desc: "提供免费WIFI"}],
                    id: 106367,
                    lowPrice: 35.5,
                    name: "星辉影城（和顺店）",
                    card:"开卡特惠 最高立减20元",
                    discount:"《你好，李焕英》等7部电影特惠"
                }
            ],
            regionList: [
                {
                    name: '全部地区'
                },
                {
                    name: '海淀区'
                }, {
                    name: '东城区'
                },{
                    name: '西城区'
                },{
                    name: '朝阳区'
                },{
                    name: '丰台区'
                },{
                    name: '顺义区'
                },{
                    name: '房山区'
                },{
                    name: '通州区'
                }
            ],
            currentRegion: '全部地区'
        }
    },
    methods: {
        chooseRegion: function (val) {
            this.currentRegion = val.name;
            this.filterRegion = false;
        },
        openRegion: function() {
            this.filterRegion = true;
        }
    }
}
</script>

<style scoped>
.region {
    height: 100%;
    width: 2rem;
    line-height: .8rem;
}
.filter {
    height: .8rem;
    color: #fff;
}
.region-layout {
    top: 100%;
    left: 0;
    width: 100%;
    min-height: 3rem;
    background: rgba(0,0,0,0.5);
    border-radius: .3rem;
    padding: .2rem;
}
.item-region {
    margin: .1rem;
    padding: .1rem .2rem;
    background: #fff;
    color: #000;
    border-radius: .1rem;
}
.cinemas-content{
    padding:.1rem .3rem 1rem;
    overflow-x: hidden;
}
.cinemas-list{
    min-height:2.7rem;
    padding: .2rem 0;
    border-bottom: .01rem solid #D2D2D2;
}
.title-and-price{
    margin-bottom:.3rem;
}
.address{
    font-size:.24rem;
    color:#8E8E8E;
    flex:1;
}
.distance{
    color: #999999;
    font-size:.18rem;
}
.features{
    margin:.1rem 0 0;
}
.features li{
    margin:0 .13rem .1rem 0;
    border-radius:.05rem;
    background: linear-gradient(-90deg, #8F7AD3 0%, #A5BDD6 100%);
    color: #FFFFFF;
    font-size:.22rem;
    padding: .02rem .1rem;
    flex-shrink: 0;
}

.title{
    font-size:.32rem;
    color: #333333;
    font-family: SourceHanSansCN;
    flex:1;
}
.price{
    color: #FF1048;
    font-size:.25rem;
    flex-shrink: 0;
}
.price span{
    font-size:.32rem;
}
.ka-wrapper{
    font-size:.24rem;
    color:#999999;
}
.ka-wrapper img{
    width:.32rem;
    height:.3rem;
    margin-right:.17rem;
    vertical-align: middle;
}

</style>